import React from "react";
import Header from "../../../components/ui/Header";
import Footer from "../../../components/ui/Footer";
import WhatsAppButton from "../../../components/ui/WhatsAppButton";

const NoVerbalCom = () => {
    return (
        <div className="text-gray-900 min-h-screen flex flex-col">
            <Header />

            <main className="flex-1 w-full pt-20 pb-16 px-5 md:px-16 flex flex-col md:flex-row items-center justify-between gap-10">

                {/* IMAGEN – arriba en móvil */}
                <div className="md:w-1/2 flex justify-center order-1 md:order-2">
                    <img
                        src="/assets/images/no-verbal-com.jpg"
                        alt="Comunicación no verbal"
                        className="rounded-2xl shadow-lg w-full max-w-sm md:max-w-full"
                    />
                </div>

                {/* TEXTO */}
                <div className="md:w-1/2 space-y-5 order-2 md:order-1">

                    <h1 className="text-3xl sm:text-4xl md:text-6xl font-headline font-bold text-indigo-900 leading-tight">
                        COMUNICACIÓN NO VERBAL
                        <span className="block w-20 h-1 bg-purple-400 rounded-full mt-3"></span>
                    </h1>

                    <p className="text-base md:text-lg leading-relaxed text-justify text-gray-700">
                        El <strong>85% de la comunicación es no verbal</strong> e involucra gestos del
                        rostro, tono de voz, postura, mirada, forma de hablar, desplazamiento corporal
                        y uso del atuendo e imagen personal.
                    </p>

                    <p className="text-base md:text-lg leading-relaxed text-justify text-gray-700">
                        A través de su estudio, las empresas más importantes del mundo logran ubicar
                        mejor a los profesionales por áreas, detectar mentiras, intentos de fraude y
                        aplicar estrategias efectivas de negociación.
                    </p>

                    <p className="text-base md:text-lg leading-relaxed text-justify text-gray-700">
                        Ofrecemos capacitaciones <strong>In House</strong> para gerentes, jefes de área
                        y procesos de selección de socios, fortaleciendo el área de recursos humanos.
                        El temario se adapta a las necesidades específicas de cada organización.
                    </p>

                    <p className="text-base md:text-lg leading-relaxed text-justify text-gray-700">
                        Además, brindamos entrenamiento en lenguaje corporal aplicado a seguridad
                        empresarial e imagen institucional. Empresarios, docentes, detectives,
                        terapeutas y profesionales de ventas y liderazgo elevan su capacidad de
                        influencia y empatía con esta valiosa disciplina.
                    </p>

                    <p className="text-base md:text-lg font-semibold text-indigo-900 text-justify">
                        ¡Contáctanos hoy mismo y maximiza el potencial de tu equipo con soluciones especializadas!
                    </p>
                </div>

                <WhatsAppButton />
            </main>

            <Footer />
        </div>
    );

};

export default NoVerbalCom;